module.exports = __webpack_public_path__ + "img/Mstorybg4.c2358d6c.jpg";